<template>
  <div class="blocked_logs_page">
    <h1>封禁日志查询</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      ></el-date-picker>
      <el-date-picker
        v-model="dateValue1"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      ></el-date-picker>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'

export default {
  components: {
    CustomTable
  },
  data() {
    return {
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      dateValue: this.$store.getters.dateTwoDayBefore,
      dateValue1: this.$store.getters.dateOneDayBefore,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate())
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'ascending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'rid',
            label: '用户ID',
            sortable: true,
            fixed: true,
            width: '180px'
          },
          {
            name: 'nickName',
            label: '用户名',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'blockedDate',
            label: '封禁时间',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'reason',
            label: '封禁原因',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'gold',
            label: '剩余金币数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'firstBlockedPicture',
            label: '第一次通话违规图片',
            sortable: true,
            fix: true,
            width: '360px'
          },
          {
            name: 'secondBlockedPicture',
            label: '第二次通话违规图片',
            sortable: true,
            fix: true,
            width: '360px'
          },
          {
            name: 'thirdBlockedPicture',
            label: '第三次通话(最近一次)违规图片',
            sortable: true,
            fix: true,
            width: '360px'
          }
        ],
        jiefeng: true
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.loading = false
    // this.getList();
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取封禁日志列表
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.blocked_logs,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateValue,
          end: this.dateValue1,
          channel: this.curChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
      for (let i = 0; i < data.length; i++) {
        data[i].newHost = data[i].newHost == true ? 'true' : 'false'
      }
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.blocked_report +
        '?token=' +
        this.token +
        '&username=' +
        this.username +
        '&start=' +
        this.dateValue +
        '&end=' +
        this.dateValue1 +
        '&channel=' +
        this.curChannel.selectValue
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
